import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6510ec56"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "row mb-6" }
const _hoisted_11 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_12 = { class: "col-lg-8 fv-row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_19 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_20 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_21 = { class: "indicator-label" }
const _hoisted_22 = { class: "indicator-progress" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_24 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_25 = { class: "card-body pt-9 pb-0" }
const _hoisted_26 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_27 = { class: "flex-grow-1" }
const _hoisted_28 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_29 = { class: "d-flex flex-column" }
const _hoisted_30 = { class: "d-flex align-items-center mb-2" }
const _hoisted_31 = { class: "text-gray-800 fs-2 fw-bolder me-1" }
const _hoisted_32 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_33 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_34 = { class: "d-flex flex-wrap" }
const _hoisted_35 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_36 = { class: "d-flex align-items-center" }
const _hoisted_37 = ["data-kt-countup-value"]
const _hoisted_38 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_39 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_40 = { class: "d-flex align-items-center" }
const _hoisted_41 = ["data-kt-countup-value"]
const _hoisted_42 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_43 = { class: "d-flex align-items-center w-200px w-sm-300px flex-column mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FactorValuesCreating = _resolveComponent("FactorValuesCreating")!
  const _component_FactorValuesEditing = _resolveComponent("FactorValuesEditing")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('create', 'ive'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewIveValue')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Form, {
              class: "form",
              onSubmit: _ctx.onSubmitCreate,
              "validation-schema": _ctx.areaSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.translate('areas')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Multiselect, {
                        modelValue: _ctx.selectedAreaCreate,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAreaCreate) = $event)),
                        requierd: true,
                        label: "title",
                        trackBy: "title",
                        searchable: true,
                        canDeselect: false,
                        options: _ctx.areasCreate,
                        placeholder: _ctx.translate('selectAreas'),
                        valueProp: "id",
                        noResultsText: _ctx.translate('noResultsFound')
                      }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate('value')), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Field, {
                        type: "number",
                        name: "price",
                        autocomplete: "off",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: _ctx.translate('price')
                      }, null, 8, ["placeholder"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_ErrorMessage, { name: "price" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.translate('isSeaView')) + ": ", 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", _hoisted_18, [
                        _createVNode(_component_Field, {
                          class: "form-check-input",
                          name: "isSeaView",
                          type: "checkbox",
                          value: true,
                          checked: "checked"
                        })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "reset",
                    class: "btn btn-white btn-active-light-primary me-2",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _toDisplayString(_ctx.translate('discard')), 1),
                  _createElementVNode("button", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.translate('saveChanges')), 1),
                    _createElementVNode("span", _hoisted_22, [
                      _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                      _hoisted_23
                    ])
                  ], 512)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.can('read', 'ive'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("h4", _hoisted_31, _toDisplayString(_ctx.translate('instantValueCloningPanel')), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", {
                            class: "fs-2 fw-bolder",
                            "data-kt-countup": "true",
                            "data-kt-countup-value": _ctx.factorsValues.length
                          }, _toDisplayString(_ctx.factorsValues.length), 9, _hoisted_37)
                        ]),
                        _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.translate('factors')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", {
                            class: "fs-2 fw-bolder",
                            "data-kt-countup": "true",
                            "data-kt-countup-value": _ctx.numberOfValues
                          }, _toDisplayString(_ctx.numberOfValues), 9, _hoisted_41)
                        ]),
                        _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.translate('totalValues')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedArea,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedArea) = $event)),
                      searchable: true,
                      required: true,
                      canDeselect: false,
                      options: _ctx.areas,
                      label: "areaName",
                      trackBy: "areaName",
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound'),
                      disabled: "disabled"
                    }, null, 8, ["modelValue", "options", "noResultsText"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_FactorValuesCreating, {
      onNewValueCreated: _ctx.refreshValues,
      "factor-data": _ctx.factorData
    }, null, 8, ["onNewValueCreated", "factor-data"]),
    _createVNode(_component_FactorValuesEditing, {
      "edit-data": _ctx.editData,
      onNewValueCreated: _ctx.refreshValues
    }, null, 8, ["edit-data", "onNewValueCreated"])
  ], 64))
}